webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccessPageComponent_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f801d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccessPageComponent_vue__ = __webpack_require__(101);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccessPageComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f801d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccessPageComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[_c('h1',[_vm._v(_vm._s(_vm.ballotData.successHeading))])]),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-row"},[_c('div',{staticClass:"rcv__start-screen-left"},[_c('h2',[_vm._v(_vm._s(_vm.ballotData.description))]),_vm._v(" "),_c('div',{staticClass:"rcv__voted-list"},_vm._l((_vm.sortedSelections.slice(0, 5)),function(selection,index){return _c('div',{key:index,staticClass:"rcv__voted-row"},[_c('div',{staticClass:"rcv__voted-left"},[_c('div',{class:['rcv__candidate-avatar', _vm.getCandidateColorClass(selection.candidate.color)]},[_c('img',{attrs:{"src":selection.candidate.image,"alt":"","width":"90","height":"90"}})])]),_vm._v(" "),_c('div',{staticClass:"rcv__voted-right"},[_c('h3',[_vm._v(_vm._s(selection.candidate.animalCandidateName))])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-right"},[_c('div',{staticClass:"rcv__text-bubble"},[_c('div',{staticClass:"rcv__text-bubble-text",domProps:{"innerHTML":_vm._s(_vm.ballotData.rightSideText)}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"rcv__link"},[_c('a',{attrs:{"href":_vm.ballotData.startOverLink,"aria-label":"start over"}},[_vm._v(_vm._s(_vm.ballotData.startOverLinkLabel))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rcv__text-bubble-arrow"},[_c('img',{attrs:{"src":__webpack_require__(46),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c0e976_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__ = __webpack_require__(103);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c0e976_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"rcv__footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__footer-row"},[(_vm.showBackButton)?_c('div',{staticClass:"rcv__footer-left"},[_c('a',{staticClass:"rcv__btn rcv__btn__primary",attrs:{"href":"#","role":"button","aria-label":"Go back to the previous page"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('back-clicked')}}},[_vm._m(0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rcv__footer-right"},[(_vm.currentState === 'initial')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Start ranking"},on:{"click":_vm.start}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.startButton))])]):(_vm.currentState === 'rankingStarted')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Start Ranking"},on:{"click":_vm.proceedToSubmit}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.startRankingButton))])]):(_vm.currentState === 'readyToSubmit')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Submit Ballot"},on:{"click":_vm.submitBallot}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.submitBallotButton))])]):(_vm.currentState === 'submittedError')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Submit Ballot"},on:{"click":_vm.handleSeeErrors}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.seeErrorsButton))])]):(_vm.currentState === 'submittedSuccess')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Submit Ballot"},on:{"click":_vm.success}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.successButtonLabel))])]):(_vm.currentState === 'seeNextError')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Submit Ballot"},on:{"click":_vm.checkErrors}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.seeNextErrorButton))])]):(_vm.currentState === 'tryRankingAgain')?_c('a',{staticClass:"rcv__btn rcv__btn__secondary",attrs:{"href":"javascript:void(0)","role":"button","aria-label":"Submit Ballot"},on:{"click":_vm.tryRanking}},[_c('span',[_vm._v(_vm._s(_vm.ballotData.tryRankingAgainButton))])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("<")]),_vm._v("  Back")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showMeettheCandidates)?_c('section',{staticClass:"start__screen-module",attrs:{"ballot-data":_vm.ballotData}},[_c('v-meetthecandidates',{attrs:{"ballot-data":_vm.ballotData}})],1):_vm._e(),_vm._v(" "),(_vm.showBallotPage)?_c('section',{staticClass:"rcv__ballot-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[_c('h1',[_vm._v(_vm._s(['seeNextError', 'tryRankingAgain'].includes(_vm.footerState) ? _vm.ballotData.submittedBallotHeading :
          _vm.ballotData.ballotHeading))])]),_vm._v(" "),_c('div',{staticClass:"rcv__choice-grid"},[_c('div',{staticClass:"rcv__choice-left"},[_c('div',{staticClass:"rcv__choice-wrapp"},[_c('div',{staticClass:"rcv__choice-head"},_vm._l((_vm.ballotData.columnHeaders),function(column,index){return _c('div',{key:index,staticClass:"rcv__choice-col"},[_c('span',[_vm._v(_vm._s(column.columnHeader))])])}),0),_vm._v(" "),_vm._l((_vm.ballotData.listOfAnimals),function(candidate,rowIndex){return _c('div',{key:rowIndex,staticClass:"rcv__choice-row"},[_c('div',{class:['rcv__choice-avatar', _vm.getCandidateColorClass(candidate.color)],attrs:{"alt":candidate.altText}},[_c('img',{attrs:{"src":candidate.image,"alt":"","width":"60","height":"60"}})]),_vm._v(" "),_vm._l((_vm.ballotData.columnHeaders),function(column,colIndex){return _c('div',{key:colIndex,staticClass:"rcv__choice-col"},[_c('label',{staticClass:"rcv__choice-box",class:{ 'rcv__error': _vm.hasError(rowIndex, colIndex), 'rcv__choice-disabled': _vm.footerState === 'seeNextError' || _vm.footerState === 'tryRankingAgain' },attrs:{"for":("choice-" + rowIndex + "-" + colIndex),"aria-label":("Select " + (column.columnHeader) + " " + (candidate.animalCandidateName)),"tabindex":"0"}},[_c('input',{attrs:{"type":"checkbox","id":("choice-" + rowIndex + "-" + colIndex),"aria-checked":_vm.isChecked(rowIndex, colIndex) ? 'true' : 'false',"hidden":""},domProps:{"checked":_vm.isChecked(rowIndex, colIndex)},on:{"change":function($event){return _vm.handleSelection(rowIndex, colIndex)}}}),_vm._v(" "),_c('span',{staticClass:"rcv__choice-checkmark",attrs:{"aria-hidden":"true"}},[_c('svg',{attrs:{"width":"35","height":"22","viewBox":"0 0 35 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2.06327 13.6747C2.20896 13.8057 8.69797 1.28287 10.6175 3.03421C10.7122 3.12033 4.7226 17.1526 4.7226 17.1526C8.09418 20.2257 15.1484 0.130537 17.0288 1.84537C17.6537 2.41449 7.2777 18.0985 8.57132 19.2779L22.4228 2.04922C22.4228 2.04922 12.2008 19.7416 12.7437 20.2358C14.6888 22.0096 23.6896 0.625251 26.4708 3.161C27.871 4.43498 17.6654 19.8797 18.0927 20.27C18.0927 20.27 29.4244 4.80601 30.0611 5.38357C30.3626 5.65783 24.3645 18.9511 24.3645 18.9511C25.8822 20.3346 32.1642 8.62037 32.4565 8.88528","stroke":"#221649","stroke-width":"3.17277","stroke-linecap":"round","stroke-linejoin":"round"}})])])])])})],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"rcv__choice-right"},[(_vm.successMessage)?_c('div',{staticClass:"rcv__choice-message"},[_c('p',[_c('span',[_c('svg',{attrs:{"width":"32","height":"31","viewBox":"0 0 32 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.6172 31C24.1776 31 31.1172 24.0604 31.1172 15.5C31.1172 6.93959 24.1776 0 15.6172 0C7.05677 0 0.117188 6.93959 0.117188 15.5C0.117188 24.0604 7.05677 31 15.6172 31ZM6.39262 16.9766L12.5054 23.3522C12.8727 23.7353 13.4681 23.7353 13.8354 23.3523L24.6503 12.0722C25.0176 11.6892 25.0176 11.0681 24.6503 10.6851L23.3204 9.29791C22.9532 8.91488 22.3577 8.91488 21.9904 9.29791L13.1704 18.4972L9.05253 14.2023C8.68529 13.8192 8.0898 13.8192 7.72256 14.2023L6.39262 15.5894C6.02538 15.9725 6.02538 16.5935 6.39262 16.9766Z","fill":"#FDF751"}})])]),_vm._v(_vm._s(_vm.successMessage))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.orderedErrors),function(error,index){return _c('div',{key:index,staticClass:"rcv__choice-message rcv__choice-message--alert"},[_c('p',[_c('span',[_c('svg',{attrs:{"width":"32","height":"31","viewBox":"0 0 32 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.0293 31C24.5897 31 31.5293 24.0604 31.5293 15.5C31.5293 6.93959 24.5897 0 16.0293 0C7.46888 0 0.529297 6.93959 0.529297 15.5C0.529297 24.0604 7.46888 31 16.0293 31ZM15.3791 17.98H16.6791L17.5991 12.18V9H14.4391V12.18L15.3791 17.98ZM14.3591 23H17.6791V19.86H14.3591V23Z","fill":"#FDF751"}})])]),_vm._v("\n              "+_vm._s(error.message)+"\n            ")])])}),_vm._v(" "),(_vm.isNoBubblesSelectedError)?_c('div',{staticClass:"rcv__choice-message rcv__choice-message--alert"},[_c('p',[_c('span',[_c('svg',{attrs:{"width":"32","height":"31","viewBox":"0 0 32 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.0293 31C24.5897 31 31.5293 24.0604 31.5293 15.5C31.5293 6.93959 24.5897 0 16.0293 0C7.46888 0 0.529297 6.93959 0.529297 15.5C0.529297 24.0604 7.46888 31 16.0293 31ZM15.3791 17.98H16.6791L17.5991 12.18V9H14.4391V12.18L15.3791 17.98ZM14.3591 23H17.6791V19.86H14.3591V23Z","fill":"#FDF751"}})])]),_vm._v(" "+_vm._s(_vm.ballotData.rcvNoBubblesAreFilledDescription))])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),(_vm.showErrorPage)?_c('section',{staticClass:"start__screen-module"},[_c('v-errorPage',{attrs:{"ballot-data":_vm.ballotData}})],1):_vm._e(),_vm._v(" "),(_vm.showSuccessPage)?_c('section',{staticClass:"start__screen-module rcv__success-module"},[_c('v-successpage',{attrs:{"ballot-data":_vm.ballotData,"sorted-selections":_vm.sortedSelections}})],1):_vm._e(),_vm._v(" "),_c('v-footer',{attrs:{"ballot-data":_vm.ballotData,"current-state":_vm.footerState,"show-back-button":_vm.showBackButton},on:{"start-clicked":_vm.handleStart,"proceed-clicked":_vm.handleProceed,"submit-clicked":_vm.handleFinalSubmit,"see-errors-clicked":_vm.seeErrors,"back-clicked":_vm.handleBack,"see-next-error-clicked":_vm.handleNextError,"try-ranking-again":_vm.rankingAgain,"how-votes-counted-clicked":_vm.howVotesCounted}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{},[_c('PracticeBallotV2')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(19);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'App',
    component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }]
}));

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da055d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(107);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da055d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PracticeBallotV2__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_main_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    "PracticeBallotV2": __WEBPACK_IMPORTED_MODULE_0__PracticeBallotV2__["a" /* default */]
  }
});

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MeetTheCandidatesComponent__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ErrorPageComponent__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SuccessPageComponent__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterComponent__ = __webpack_require__(102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PracticeBallotV2",
  inject: ['rcvV2PageId'],
  data: function data() {
    return {
      ballotData: null,
      loading: true,
      error: null,
      showPracticeBallot: false,
      selectedGrid: [],
      rowError: null,
      colError: null,
      columnGapError: null,
      successMessage: null,
      isBallotSubmitted: false,
      isError: false,
      showMeettheCandidates: false,
      showBallotPage: false,
      showErrorPage: false,
      showSuccessPage: false,
      footerState: 'initial',
      showBackButton: false,
      errorRows: [],
      errorCols: [],
      columnGaps: [],
      emptyBallot: false,
      currentErrorType: null,
      isLastError: false,
      shownoBubblesSelectedError: null,
      isNoBubblesSelectedError: false,
      orderedErrors: []

    };
  },

  computed: {
    sortedSelections: function sortedSelections() {
      var selections = [];

      // For each column (rank)
      for (var colIndex = 0; colIndex < this.ballotData.columnHeaders.length; colIndex++) {
        // Find which candidate (row) was selected for this rank
        for (var rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
          if (this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex]) {
            // Add this candidate with their rank
            selections.push({
              candidate: this.ballotData.listOfAnimals[rowIndex],
              rank: colIndex
            });
            break; // Only one selection per column is valid
          }
        }
      }

      // Sort by rank (should already be sorted, but just to be sure)
      return selections.sort(function (a, b) {
        return a.rank - b.rank;
      });
    }
  },
  components: {
    "v-meetthecandidates": __WEBPACK_IMPORTED_MODULE_2__components_MeetTheCandidatesComponent__["a" /* default */],
    "v-errorPage": __WEBPACK_IMPORTED_MODULE_3__components_ErrorPageComponent__["a" /* default */],
    "v-successpage": __WEBPACK_IMPORTED_MODULE_4__components_SuccessPageComponent__["a" /* default */],
    "v-footer": __WEBPACK_IMPORTED_MODULE_5__components_FooterComponent__["a" /* default */]
  },
  methods: {
    howVotesCounted: function howVotesCounted() {
      var url = this.ballotData.seeHowVotesAreCounted;
      if (url) {
        window.location.href = url; // or use `window.open(url, '_blank')` to open in new tab
      }
    },
    removeError: function removeError(type) {
      this.orderedErrors = this.orderedErrors.filter(function (err) {
        return err.type !== type;
      });
    },
    addError: function addError(type, message) {
      // Prevent duplicates
      if (!this.orderedErrors.find(function (err) {
        return err.type === type;
      })) {
        this.orderedErrors.unshift({ type: type, message: message });
      }
    },
    getCandidateColorClass: function getCandidateColorClass(color) {
      var colorClassMap = {
        "#fdf751": "rcv__choice-color-2",
        "#221649": "rcv__choice-color-4",
        "#4ba3b7": "rcv__choice-color-1",
        "#ed7aca": "rcv__choice-color-3",
        "#eb5534": "rcv__choice-color-5",
        "#367d54": "rcv__choice-color-6"
      };

      return colorClassMap[color] || "rcv__choice-color-6"; // default class
    },
    rankingAgain: function rankingAgain() {
      this.isNoBubblesSelectedError = false;
      this.footerState = 'readyToSubmit';
      this.clearBallotSelections();
      this.clearErrors();
      this.isLastError = false;
    },
    handleNextError: function handleNextError() {
      var _this = this;

      // Define the order of error types to cycle through
      var errorTypes = ['empty', 'row', 'column', 'gap'];

      // Create a filtered list of active error types
      var activeErrorTypes = [];
      if (this.emptyBallot) activeErrorTypes.push('empty');
      if (this.errorRows.length > 0) activeErrorTypes.push('row');
      if (this.errorCols.length > 0) activeErrorTypes.push('column');
      if (this.columnGaps.length > 0) activeErrorTypes.push('gap');

      if (activeErrorTypes.length === 0) return; // No errors to show

      // Find the current index
      var currentIndex = activeErrorTypes.indexOf(this.currentErrorType);

      // Move to the next error type
      var nextIndex = (currentIndex + 1) % activeErrorTypes.length;
      this.currentErrorType = activeErrorTypes[nextIndex];
      // Check if this is the last error
      this.isLastError = nextIndex === activeErrorTypes.length - 1;
      if (this.isLastError === true) {
        this.footerState = 'tryRankingAgain';
      }
      // Focus on the current error type
      this.$nextTick(function () {
        _this.focusOnCurrentErrorType();
      });
    },
    hasError: function hasError(rowIndex, colIndex) {
      // Only highlight errors when we're in error viewing mode
      if (this.footerState !== 'submittedError' && this.footerState !== 'seeNextError' && this.footerState !== 'tryRankingAgain') {
        return false;
      }

      // Empty ballot case - highlight all cells
      if (this.currentErrorType === 'empty' && this.emptyBallot) {
        return true;
      }

      // Row error - highlight only cells in the error rows that are selected
      if (this.currentErrorType === 'row' && this.errorRows.includes(rowIndex) && this.selectedGrid[rowIndex][colIndex]) {
        return true;
      }

      // Column error - highlight only cells in the error columns that are selected
      if (this.currentErrorType === 'column' && this.errorCols.includes(colIndex) && this.selectedGrid[rowIndex][colIndex]) {
        return true;
      }

      // Gap error - highlight only the gap columns
      if (this.currentErrorType === 'gap' && this.columnGaps.includes(colIndex)) {
        return true;
      }

      return false;
    },
    seeErrors: function seeErrors() {
      var _this2 = this;

      this.footerState = 'seeNextError';
      this.showErrorPage = false;
      this.showBallotPage = true;

      // Reset error arrays
      this.errorRows = [];
      this.errorCols = [];
      this.columnGaps = [];
      this.emptyBallot = false;

      // Check if there are no selections at all
      var hasAnySelection = this.selectedGrid.some(function (row) {
        return row && row.some(function (cell) {
          return cell === true;
        });
      });

      if (!hasAnySelection) {
        // Mark the ballot as empty to highlight all cells
        this.footerState = 'tryRankingAgain';
        this.emptyBallot = true;
        this.currentErrorType = 'empty';
        this.isNoBubblesSelectedError = true;
        return;
      }

      // Check for row errors - rows with multiple selections
      for (var rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
        var row = this.selectedGrid[rowIndex];
        if (row) {
          var rowSelections = row.filter(Boolean).length;
          if (rowSelections > 1) {
            this.errorRows.push(rowIndex);
          }
        }
      }

      // Check for column errors - columns with multiple selections
      var columnCount = this.ballotData.columnHeaders.length;
      for (var colIndex = 0; colIndex < columnCount; colIndex++) {
        var colSelections = 0;
        for (var _rowIndex = 0; _rowIndex < this.selectedGrid.length; _rowIndex++) {
          if (this.selectedGrid[_rowIndex] && this.selectedGrid[_rowIndex][colIndex]) {
            colSelections++;
          }
        }
        if (colSelections > 1) {
          this.errorCols.push(colIndex);
        }
      }

      // Check for column gaps
      var selectedColumns = Array(columnCount).fill(false);
      this.selectedGrid.forEach(function (row) {
        if (row) {
          row.forEach(function (isSelected, index) {
            if (isSelected) {
              selectedColumns[index] = true;
            }
          });
        }
      });

      var firstSelected = selectedColumns.findIndex(function (val) {
        return val;
      });
      var lastSelected = selectedColumns.lastIndexOf(true);

      // Modified gap checking logic
      if (firstSelected !== -1) {
        // Only if there's at least one selection
        // If first column isn't selected but a later column is
        if (firstSelected > 0) {
          // Add all columns from 0 to firstSelected-1 as gaps
          for (var i = 0; i < firstSelected; i++) {
            this.columnGaps.push(i);
          }
        }

        // Check for gaps between first and last selected
        if (lastSelected > firstSelected) {
          for (var _i = firstSelected + 1; _i < lastSelected; _i++) {
            if (!selectedColumns[_i]) {
              this.columnGaps.push(_i);
            }
          }
        }
      }

      if (this.errorRows.length === 0 && this.errorCols.length === 0 && this.columnGaps.length > 0) {
        this.footerState = 'tryRankingAgain';
        this.currentErrorType = 'gap';
        return;
      }
      // Count the number of different error types present
      var errorTypes = [this.errorRows.length > 0, this.errorCols.length > 0, this.columnGaps.length > 0];
      var totalErrorTypes = errorTypes.filter(Boolean).length;

      // If there's only one type of error, set footerState to 'tryRankingAgain'
      if (totalErrorTypes === 1) {
        this.footerState = 'tryRankingAgain';
      }

      // Set the initial error type to focus on
      if (this.errorRows.length > 0) {
        this.currentErrorType = 'row';
      } else if (this.errorCols.length > 0) {
        this.currentErrorType = 'column';
      } else if (this.columnGaps.length > 0) {
        this.currentErrorType = 'gap';
      }
      // On the next tick, after the DOM is updated, focus on the first error
      this.$nextTick(function () {
        _this2.focusOnCurrentErrorType();
      });
    },
    focusOnCurrentErrorType: function focusOnCurrentErrorType() {
      var selector = void 0;

      // Clear all previously added errors to show only the current one
      this.orderedErrors = [];

      if (this.currentErrorType === 'empty') {
        selector = '.rcv__choice-box:first-child';
        this.addError('empty', this.ballotData.noBubblesSelected);
      } else if (this.currentErrorType === 'row' && this.errorRows.length > 0) {
        var rowIndex = this.errorRows[0];
        var colIndex = 0;
        if (this.selectedGrid[rowIndex]) {
          colIndex = this.selectedGrid[rowIndex].findIndex(function (cell) {
            return cell === true;
          });
          if (colIndex === -1) colIndex = 0;
        }
        selector = ".rcv__choice-row:nth-child(" + (rowIndex + 1) + ") .rcv__choice-col:nth-child(" + (colIndex + 1) + ") .rcv__choice-box";
        this.addError('row', this.ballotData.moreThanOneBubbleSelectedInARow);
      } else if (this.currentErrorType === 'column' && this.errorCols.length > 0) {
        var _colIndex = this.errorCols[0];
        var _rowIndex2 = 0;
        for (var i = 0; i < this.selectedGrid.length; i++) {
          if (this.selectedGrid[i] && this.selectedGrid[i][_colIndex]) {
            _rowIndex2 = i;
            break;
          }
        }
        selector = ".rcv__choice-row:nth-child(" + (_rowIndex2 + 1) + ") .rcv__choice-col:nth-child(" + (_colIndex + 1) + ") .rcv__choice-box";
        this.addError('column', this.ballotData.rcvMore1BubbleInAColDescription);
      } else if (this.currentErrorType === 'gap' && this.columnGaps.length > 0) {
        var _colIndex2 = this.columnGaps[0];
        selector = ".rcv__choice-row:first-child .rcv__choice-col:nth-child(" + (_colIndex2 + 1) + ") .rcv__choice-box";
        this.addError('gap', this.ballotData.gapBetweenColumnsValidationDescription);
      }

      // Focus on the corresponding UI element
      // if (selector) {
      //   this.$nextTick(() => {
      //     // debugger;
      //     const errorElement = document.querySelector(selector);
      //     if (errorElement) {
      //       errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //       errorElement.focus();
      //     }
      //   });
      // }
    },
    clearErrors: function clearErrors() {
      this.errorRows = [];
      this.errorCols = [];
      this.columnGaps = [];
      this.currentErrorType = null;
      this.emptyBallot = false;
      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.orderedErrors = [];
    },
    clearBallotSelections: function clearBallotSelections() {
      var _this3 = this;

      if (this.ballotData) {
        var newGrid = Array(this.ballotData.listOfAnimals.length).fill(null).map(function () {
          return Array(_this3.ballotData.columnHeaders.length).fill(false);
        });

        this.$set(this, 'selectedGrid', newGrid);
      }
    },
    getCurrentPage: function getCurrentPage() {
      if (this.showSuccessPage) return 'success';
      if (this.showErrorPage) return 'error';
      if (this.showBallotPage) return 'ballot';
      if (this.showMeettheCandidates) return 'meetCandidates';
      return 'initial';
    },
    handleBack: function handleBack() {
      var _this4 = this;

      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.successMessage = null;

      // Handle back button when viewing errors
      if (this.footerState === 'seeNextError' || this.footerState === 'tryRankingAgain') {
        // Get the current error types in reverse order for proper back navigation
        var errorTypes = ['empty', 'row', 'column', 'gap'].filter(function (type) {
          if (type === 'empty') return _this4.emptyBallot;
          if (type === 'row') return _this4.errorRows.length > 0;
          if (type === 'column') return _this4.errorCols.length > 0;
          if (type === 'gap') return _this4.columnGaps.length > 0;
          return false;
        });

        if (errorTypes.length === 0) {
          // If no errors to navigate back to, return to the ballot page
          this.footerState = 'readyToSubmit';
          return;
        }

        // Find the current index
        var currentIndex = errorTypes.indexOf(this.currentErrorType);

        if (currentIndex <= 0) {
          // If at the first error or no current error, go back to error page
          this.showErrorPage = true;
          this.showBallotPage = false;
          this.footerState = 'submittedError';
        } else {
          // Go to the previous error type
          this.currentErrorType = errorTypes[currentIndex - 1];
          this.isLastError = false;
          this.footerState = 'seeNextError'; // Ensure footer state is consistent

          // Focus on the previous error type
          this.$nextTick(function () {
            _this4.focusOnCurrentErrorType();
          });
        }
        return;
      }

      // Handle other states as before
      if (this.showSuccessPage) {
        this.showSuccessPage = false;
        this.showBallotPage = true;
        this.footerState = 'readyToSubmit';
        this.clearBallotSelections();
        return;
      }

      if (this.showErrorPage) {
        // debugger;
        this.showErrorPage = false;
        this.showBallotPage = true;
        this.footerState = 'readyToSubmit';
        this.validateSelections();
        this.removeError('columnGap');
        this.isNoBubblesSelectedError = false;
        this.columnGaps = [];
      } else if (this.showBallotPage) {
        this.showBallotPage = false;
        this.showMeettheCandidates = true;
        this.footerState = 'rankingStarted';
      } else if (this.showMeettheCandidates) {
        this.showMeettheCandidates = false;
        this.footerState = 'initial';
        this.showBackButton = false;
      }
    },
    handleStart: function handleStart() {
      this.footerState = 'rankingStarted';
      this.showBackButton = true;
      this.showMeettheCandidates = true;
    },
    handleProceed: function handleProceed() {
      this.clearBallotSelections();
      this.clearErrors();
      this.footerState = 'readyToSubmit';
      this.showBallotPage = true;
      this.showMeettheCandidates = false;
    },
    handleFinalSubmit: function handleFinalSubmit() {

      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.successMessage = null;
      // Check if there are no selections at all
      var hasAnySelection = this.selectedGrid.some(function (row) {
        return row && row.some(function (cell) {
          return cell === true;
        });
      });

      if (!hasAnySelection) {
        this.isError = true;
        this.footerState = 'submittedError';
        this.showErrorPage = true;
        this.showBallotPage = false;
        this.showSuccessPage = false;
        return;
      }

      var isValid = this.validateSelections();
      var gapIsValid = this.checkColumnGapError();

      if (!isValid || !gapIsValid) {
        this.footerState = 'submittedError';
        this.showErrorPage = true;
        this.showBallotPage = false;
        this.showSuccessPage = false;
      } else {
        this.showBackButton = false;
        this.footerState = 'submittedSuccess'; // Set explicitly
        this.showSuccessPage = true;
        this.showBallotPage = false;
        this.showErrorPage = false;
      }
    },
    checkColumnGapError: function checkColumnGapError() {
      var columnCount = this.ballotData.columnHeaders.length;
      var selectedColumns = Array(columnCount).fill(false);

      this.selectedGrid.forEach(function (row) {
        if (row) {
          row.forEach(function (isSelected, index) {
            if (isSelected) {
              selectedColumns[index] = true;
            }
          });
        }
      });

      var firstSelected = selectedColumns.findIndex(function (val) {
        return val;
      });
      var lastSelected = selectedColumns.lastIndexOf(true);

      if (firstSelected !== -1 && lastSelected !== -1) {
        for (var i = firstSelected; i <= lastSelected; i++) {
          if (!selectedColumns[i]) {
            this.addError('columnGap', this.ballotData.gapBetweenColumnsValidationDescription);
            return false;
          }
        }
      }

      // If column 0 is not selected but other columns are
      if (!selectedColumns[0] && selectedColumns.some(function (val, index) {
        return index > 0 && val;
      })) {
        this.addError('columnGap', this.ballotData.gapBetweenColumnsValidationDescription);
        return false;
      }

      // ✅ All good — explicitly return true
      return true;
    },
    getBallotData: function getBallotData() {
      var _this5 = this;

      //let pageId = 4886; 
      var pageId = window.rcvV2PageId;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(location.origin + "/v2practicercv/getballotData?id=" + pageId)
      // axios.get(`http://localhost:63238/v2practicercv/getballotData?id=4886`)
      //axios.get(`https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getballotData?id=2248`)
      .then(function (response) {
        _this5.ballotData = response.data;
        // Initialize selection grid
        _this5.selectedGrid = Array(_this5.ballotData.listOfAnimals.length).fill(null).map(function () {
          return Array(_this5.ballotData.columnHeaders.length).fill(false);
        });
      }).catch(function (error) {
        _this5.error = 'Failed to load ballot data';
      }).finally(function () {
        _this5.loading = false;
      });
    },
    isChecked: function isChecked(rowIndex, colIndex) {
      return this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex] === true;
    },
    validateSelections: function validateSelections() {
      var hasRowError = false;
      var hasColError = false;
      // let hasColumnGapError = false;

      // ----- ROW ERROR CHECK -----
      var foundRowError = false;
      for (var rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
        var row = this.selectedGrid[rowIndex];
        if (row) {
          var rowSelections = row.filter(Boolean).length;
          if (rowSelections > 1) {
            this.rowError = this.ballotData.moreThanOneBubbleSelectedInARow;
            this.addError('row', this.rowError);
            hasRowError = true;
            foundRowError = true;
            break;
          }
        }
      }
      if (!foundRowError) {
        this.rowError = '';
        this.removeError('row');
      }

      // ----- COLUMN ERROR CHECK -----
      var foundColError = false;
      var columnCount = this.ballotData.columnHeaders.length;
      for (var colIndex = 0; colIndex < columnCount; colIndex++) {
        var colSelections = 0;
        for (var _rowIndex3 = 0; _rowIndex3 < this.selectedGrid.length; _rowIndex3++) {
          if (this.selectedGrid[_rowIndex3] && this.selectedGrid[_rowIndex3][colIndex]) {
            colSelections++;
          }
        }
        if (colSelections > 1) {
          this.colError = this.ballotData.rcvMore1BubbleInAColDescription;
          this.addError('column', this.colError);
          hasColError = true;
          foundColError = true;
          break;
        }
      }
      if (!foundColError) {
        this.colError = '';
        this.removeError('column');
      }
      return !(hasRowError || hasColError);
    },
    handleSelection: function handleSelection(rowIndex, colIndex) {
      // If we're in error review mode, don't allow selection changes
      if (this.footerState === 'seeNextError' || this.footerState === 'tryRankingAgain') {
        return;
      }
      // Reset success message
      this.successMessage = null;

      // Initialize row if it doesn't exist
      if (!this.selectedGrid[rowIndex]) {
        this.$set(this.selectedGrid, rowIndex, []);
      }

      // Toggle current selection
      var current = this.selectedGrid[rowIndex][colIndex];
      this.$set(this.selectedGrid[rowIndex], colIndex, !current);

      // Reset error messages
      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;

      // Check if there are any selections at all
      var hasAnySelection = this.selectedGrid.some(function (row) {
        return row && row.some(function (cell) {
          return cell === true;
        });
      });

      if (!hasAnySelection) {
        this.successMessage = null;
        return;
      }
      var isValid = this.validateSelections();

      if (isValid) {
        var totalSelections = this.selectedGrid.reduce(function (acc, row) {
          if (!row) return acc;
          return acc + row.filter(function (cell) {
            return cell === true;
          }).length;
        }, 0);

        if (totalSelections === 1) {
          this.successMessage = this.ballotData.success;
        } else if (totalSelections === 5) {

          this.successMessage = this.ballotData.selectionCompletedMessage;
        } else {
          this.successMessage = false;
        }
      }
    },
    setupChoiceBoxes: function setupChoiceBoxes() {
      var _this6 = this;

      this.$nextTick(function () {
        var choiceBoxes = document.querySelectorAll(".rcv__choice-box");
        var isMobile = window.innerWidth <= 768; // Check if it's mobile view

        if (choiceBoxes && choiceBoxes.length > 0) {
          choiceBoxes.forEach(function (box, index) {
            var checkbox = box.querySelector("input[type='checkbox']");
            if (!checkbox) return;

            // Clean up old event listeners to prevent duplicates
            if (box._clickHandler) {
              box.removeEventListener("click", box._clickHandler);
            }
            if (checkbox._changeHandler) {
              checkbox.removeEventListener("change", checkbox._changeHandler);
            }
            if (box._keydownHandler) {
              box.removeEventListener("keydown", box._keydownHandler);
            }
            // Get the row and column indices
            var currentRow = box.closest('.rcv__choice-row');
            var currentCol = box.closest('.rcv__choice-col');
            var rowIndex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(currentRow.parentElement.children).indexOf(currentRow) - 1; // -1 to account for header
            var colIndex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(currentRow.children).indexOf(currentCol) - 1; // -1 to account for avatar

            // Get the candidate name and column header
            var candidateName = _this6.ballotData.listOfAnimals[rowIndex].animalCandidateName;
            var columnHeader = _this6.ballotData.columnHeaders[colIndex].columnHeader;
            // const ariaLabel = `Select ${columnHeader} ${candidateName}`;

            // Set the ARIA label
            // checkbox.setAttribute("aria-label", ariaLabel);

            // Move ARIA attributes to the checkbox input instead of the wrapper
            //checkbox.setAttribute("aria-label", `Select option ${index + 1}`);
            checkbox.setAttribute("aria-disabled", box.classList.contains("rcv__choice-disabled") ? "true" : "false");

            // Remove invalid ARIA attributes from wrapper
            box.removeAttribute("role");
            box.removeAttribute("aria-checked");
            box.removeAttribute("aria-disabled");
            // box.removeAttribute("aria-label");

            // Change handler for the checkbox
            var changeHandler = function changeHandler(event) {
              // Update ARIA attributes
              box.setAttribute("aria-checked", checkbox.checked);

              // Trigger auto-scroll only on mobile
              if (isMobile && checkbox.checked) {
                // Important: Use setTimeout to ensure DOM has updated
                setTimeout(function () {
                  var choiceRow = box.closest('.rcv__choice-row');
                  if (choiceRow) {
                    var avatar = choiceRow.querySelector('.rcv__choice-avatar');
                    if (avatar) {
                      avatar.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }
                }, 50);
              }
            };

            // Add change event listener
            checkbox.addEventListener("change", changeHandler);
            checkbox._changeHandler = changeHandler;

            // Click handler for the box
            var clickHandler = function clickHandler(event) {
              if (event.target === checkbox) {
                return;
              }
              event.preventDefault();
              checkbox.checked = !checkbox.checked;
              var changeEvent = new Event("change", { bubbles: true });
              checkbox.dispatchEvent(changeEvent);
            };

            // Add click event listener
            box.addEventListener("click", clickHandler);
            box._clickHandler = clickHandler;

            if (!box.hasAttribute("tabindex")) {
              box.setAttribute("tabindex", "0");
            }

            // Keyboard navigation handler
            var keydownHandler = function keydownHandler(event) {
              var key = event.key;
              var currentRow = box.closest('.rcv__choice-row');
              var currentCol = box.closest('.rcv__choice-col');

              switch (key) {
                case 'Enter':
                case ' ':
                  event.preventDefault();
                  if (!box.classList.contains("rcv__choice-disabled")) {
                    checkbox.checked = !checkbox.checked;
                    box.setAttribute("aria-checked", checkbox.checked);
                    var changeEvent = new Event("change", { bubbles: true });
                    checkbox.dispatchEvent(changeEvent);
                  }
                  break;

                case 'ArrowUp':
                  event.preventDefault();
                  var prevRow = currentRow.previousElementSibling;
                  if (prevRow) {
                    var prevBox = prevRow.querySelector(".rcv__choice-col:nth-child(" + (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(currentRow.children).indexOf(currentCol) + 1) + ") .rcv__choice-box");
                    if (prevBox) prevBox.focus();
                  }
                  break;

                case 'ArrowDown':
                  event.preventDefault();
                  var nextRow = currentRow.nextElementSibling;
                  if (nextRow) {
                    var nextBox = nextRow.querySelector(".rcv__choice-col:nth-child(" + (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(currentRow.children).indexOf(currentCol) + 1) + ") .rcv__choice-box");
                    if (nextBox) nextBox.focus();
                  }
                  break;

                case 'ArrowLeft':
                  event.preventDefault();
                  var prevCol = currentCol.previousElementSibling;
                  if (prevCol && prevCol.classList.contains('rcv__choice-col')) {
                    var _prevBox = prevCol.querySelector('.rcv__choice-box');
                    if (_prevBox) _prevBox.focus();
                  }
                  break;

                case 'ArrowRight':
                  event.preventDefault();
                  var nextCol = currentCol.nextElementSibling;
                  if (nextCol && nextCol.classList.contains('rcv__choice-col')) {
                    var _nextBox = nextCol.querySelector('.rcv__choice-box');
                    if (_nextBox) _nextBox.focus();
                  }
                  break;
              }
            };

            // Add keydown event listener
            box.removeEventListener("keydown", box._keydownHandler); // Remove old listener
            box.addEventListener("keydown", keydownHandler);
            box._keydownHandler = keydownHandler;
          });
        }

        // Add window resize listener to update mobile detection
        if (!_this6._resizeHandler) {
          _this6._resizeHandler = function () {
            var newIsMobile = window.innerWidth <= 768;
            if (newIsMobile !== isMobile) {
              _this6.setupChoiceBoxes();
            }
          };
          window.addEventListener('resize', _this6._resizeHandler);
        }
      });
    }
  },
  mounted: function mounted() {
    this.getBallotData();
    // this.setupChoiceBoxes();

    // Add resize listener for responsive behavior
    window.addEventListener('resize', function () {
      // this.setupChoiceBoxes();
    });
  },
  updated: function updated() {
    var _this7 = this;

    this.$nextTick(function () {
      _this7.setupChoiceBoxes();
    });
  },
  beforeDestroy: function beforeDestroy() {
    // Clean up event listeners
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MeetheCandidatesComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {};
  },


  computed: {},

  methods: {
    getCandidateColorClass: function getCandidateColorClass(color) {

      var colorClassMap = {
        "#fdf751": "rcv__candidate-color-1",
        "#221649": "rcv__candidate-color-2",
        "#4ba3b7": "rcv__candidate-color-3",
        "#ed7aca": "rcv__candidate-color-4",
        "#eb5534": "rcv__candidate-color-5",
        "#367d54": "rcv__candidate-color-6"
      };

      return colorClassMap[color] || "rcv__candidate-color-6"; // default class
    }
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ErrorPageComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {};
  },


  computed: {},

  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAzMyA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF83NzA3XzI2NTYzKSI+DQo8cGF0aCBkPSJNMjkuMjIyOCAwSDIwLjkzMjhMMjAuNzQ5NiAwLjgwNDQ4M0wxOS4zNzU1IDYuOTU2NDFMMTkuMTQ2NSA3Ljk5NzUxTDE3LjU0MzQgMTQuMDA3NUwxNC4yOTE1IDI1Ljc5MDhMMTQuMTA4MyAyOC42MzAxQzE0LjAxNjcgMjkuMTAzNCAxMy4zNzU1IDI5LjEwMzQgMTMuMjgzOSAyOC42MzAxTDEzLjE0NjUgMjUuNzkwOEw4LjYxMjE1IDcuNzYwOUwwLjIzMDQ2OSA3Ljk1MDE5TDguMTU0MTMgMzhIMTkuMTQ2NUwyNi45MzI4IDcuOTk3NTFIMzAuMjMwNSIgZmlsbD0iI0VEN0FDQSIvPg0KPC9nPg0KPGRlZnM+DQo8Y2xpcFBhdGggaWQ9ImNsaXAwXzc3MDdfMjY1NjMiPg0KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjQwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yMzA0NjkpIi8+DQo8L2NsaXBQYXRoPg0KPC9kZWZzPg0KPC9zdmc+DQo="

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SuccessPageComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    },
    sortedSelections: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },


  computed: {},

  methods: {
    getCandidateColorClass: function getCandidateColorClass(color) {
      var colorClassMap = {
        "#fdf751": "rcv__candidate-color-1",
        "#221649": "rcv__candidate-color-2",
        "#4ba3b7": "rcv__candidate-color-3",
        "#ed7aca": "rcv__candidate-color-4",
        "#eb5534": "rcv__candidate-color-5",
        "#367d54": "rcv__candidate-color-6"
      };
      return colorClassMap[color] || "rcv__candidate-color-6"; // default class
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterComponent",

  props: {
    ballotData: Object,
    currentState: {
      type: String,
      validator: function validator(val) {
        return ['initial', 'rankingStarted', 'readyToSubmit', 'submittedError', 'seeNextError', 'tryRankingAgain'].includes(val);
      }
    },
    showBackButton: Boolean,
    isLastError: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentState: function currentState(newVal) {
      var grid = document.getElementById('rcv__content');
      if (grid) {
        grid.style.display = newVal === 'initial' ? 'block' : 'none';
      }
    }
  },
  methods: {
    start: function start() {
      var grid = document.getElementById('rcv__content');
      if (grid) {
        grid.style.display = 'none';
      }
      this.$emit('start-clicked');
    },
    proceedToSubmit: function proceedToSubmit() {
      this.$emit('proceed-clicked');
    },
    submitBallot: function submitBallot() {
      this.$emit('submit-clicked');
    },
    handleSeeErrors: function handleSeeErrors() {
      this.$emit('see-errors-clicked');
    },
    success: function success() {
      this.$emit('how-votes-counted-clicked');
    },
    checkErrors: function checkErrors() {
      this.$emit('see-next-error-clicked');
    },
    tryRanking: function tryRanking() {
      this.$emit('try-ranking-again');
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
// console.log('window.rcvV2PageId:', window.rcvV2PageId);
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  provide: {
    rcvV2PageId: window.rcvV2PageId
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeBallotV2_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205fb6a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PracticeBallotV2_vue__ = __webpack_require__(104);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PracticeBallotV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205fb6a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PracticeBallotV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetTheCandidatesComponent_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054d5eed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeetTheCandidatesComponent_vue__ = __webpack_require__(97);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetTheCandidatesComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054d5eed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeetTheCandidatesComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[_c('h1',[_vm._v(_vm._s(_vm.ballotData.heading))])]),_vm._v(" "),_c('div',{staticClass:"rcv__canditate-row"},_vm._l((_vm.ballotData.listOfAnimals),function(candidate,index){return _c('div',{key:index,staticClass:"rcv__canditate-col"},[_c('div',{staticClass:"rcv__canditate-card"},[_c('div',{staticClass:"rcv__canditate-profile"},[_c('div',{class:['rcv__candidate-avatar', _vm.getCandidateColorClass(candidate.color)]},[_c('img',{attrs:{"src":candidate.image,"alt":candidate.altText,"width":"90","height":"90"}})])]),_vm._v(" "),_c('div',{staticClass:"rcv__canditate-details"},[_c('h3',[_vm._v(_vm._s(candidate.animalCandidateName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(candidate.description))])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPageComponent_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc9c9ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPageComponent_vue__ = __webpack_require__(99);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPageComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc9c9ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPageComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rcv__heading-v1"},[_c('h1',[_vm._v(_vm._s(_vm.ballotData.errorHeading))])]),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-row"},[(_vm.ballotData.image)?_c('div',{staticClass:"rcv__start-screen-left"},[_c('img',{attrs:{"src":_vm.ballotData.image,"alt":_vm.ballotData.altText,"width":"800","height":"379"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rcv__start-screen-right"},[_c('div',{staticClass:"rcv__text-bubble"},[_c('div',{staticClass:"rcv__text-bubble-text",domProps:{"innerHTML":_vm._s(_vm.ballotData.textMessage)}}),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rcv__text-bubble-arrow"},[_c('img',{attrs:{"src":__webpack_require__(46),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[49]);


// WEBPACK FOOTER //
// static/js/app.87b3c756c858957e08b9.js